import { connect } from 'react-redux';
import { IMortgageLandingProps, MortgageLanding } from '../../components/MortgageLanding';
import { IApplicationState } from '../../types/redux';
import { parseRealtyType } from './RealtyTypeParser';

export const mapStateToProps = ({ mortgage }: IApplicationState): IMortgageLandingProps => {
  return {
    initialpayment: mortgage.filterDownPayment,
    propertyamount: mortgage.filterRealtyPrice,
    loanterm: mortgage.filterTerms,
    realtytype: parseRealtyType(mortgage.filterBuildingType),
    regionid: mortgage.filterRegionId,
    pagetype: 'frontend_mainpage',
  };
};

export const MortgageLandingContainer = connect(mapStateToProps)(MortgageLanding);
